import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FirewallRule } from '../../@types/firewall-rule';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    groupId: string;
    body: FirewallRule;
}

export function useCreateSecurityGroupRuleMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ groupId, body }: Vars) =>
            Endpoints.v1.Firewalls.SecurityGroupRules.createRule(groupId, body),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-group-rules', vars.groupId],
            });
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-groups.infinite'],
            });
            notifications.show({
                title: t('securityGroup.ruleAddedTitle'),
                message: t('securityGroup.ruleAddedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('securityGroup.ruleAddFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
